import styled from 'styled-components';

export default styled.main`
	--template-nav-size: var(--px-56);
	--template-padding-sides: var(--px-56);
	--template-separator: var(--px-1) solid var(--header--border-color);
	display: flex;
	flex: 1;
	overflow: hidden;
	margin: 0 auto;
    max-width: 2048px;
	.customScrollbar {
		scrollbar-gutter: stable;
	}
`;
